import React, { useState, useRef } from "react";
import "../assets/css/ConfirmJoinModal.css";

export default function TermsModal({ open, onAccept }) {
  const [canAccept, setCanAccept] = useState(false);
  const scrollRef = useRef(null);

  if (!open) return null;

  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;

    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
      setCanAccept(true);
    }
  };

  return (
    <div className="cjm-terms-backdrop">
      <div className="cjm-terms-modal">

        {/* ❌ Close button removed */}

        <div className="cjm-terms-header">
          <h2>Terms & Conditions</h2>
        </div>

        <div
          className="cjm-terms-body"
          ref={scrollRef}
          onScroll={handleScroll}
        >
          <div className="terms-wrapper">
            <div className="terms-container">

              <h3>Acceptance of Terms</h3>
              <h5>Liability Disclaimer</h5>

              <p>
               IBullz Company makes no warranties or representations, express or implied, regarding the products or services offered through this platform. The company accepts no liability for any damages or losses arising from the use of, or reliance on, its products, services, or information provided on the platform.
              </p>

              <h5>Unless otherwise specified:</h5>
              <p>
                Returns, expense ratios, NAV, or similar metrics are historical and for illustrative purposes only.
                Future performance may vary significantly depending on market conditions and individual circumstances.
                Information provided on this platform or blog is for educational and informational purposes only and does not constitute financial, investment, or tax advice.
              </p>

              <h5>Risk Disclosure</h5>
              <p>
               Investments in financial markets are subject to market risks. Please read all related documents carefully before investing.
               Crypto market investments are highly volatile and subject to significant market risks.
               Users should conduct their own research (DYOR) before investing in any crypto assets.
               Past performance of crypto assets does not guarantee future results.
              </p>

              <h5>Crypto Trading & Investment Disclaimer</h5>
              <p>
                Cryptocurrency trading and investments involve high risk and market volatility. Prices of digital assets can fluctuate significantly, and users may lose part or all of their invested capital.
                IBullz Company provides a platform for cryptocurrency exchange and trading but does not provide financial, investment, legal, or tax advice. All information, charts, and market data on this platform are for informational and educational purposes only.          
                Users should conduct their own research (DYOR) before making any trading or investment decisions. Past performance of any cryptocurrency does not guarantee future results.          
                By using this platform, you acknowledge and accept the risks associated with cryptocurrency trading and investment.

              </p>

              <h5>Crypto Exchange, Trading & Investment DisclaimerGeneral Disclaimer</h5>
              <p>
                IBullz Company provides a platform for cryptocurrency exchange, trading, and digital asset investment services. By accessing or using this platform, users acknowledge and agree that cryptocurrency trading and investments involve substantial risk.

The services provided by the platform are intended solely for informational and transactional purposes. The company does not guarantee the accuracy, completeness, or reliability of any information provided on the platform.

All users are responsible for conducting their own research and making independent investment decisions.

No Financial or Investment Advice

The information available on this platform, including but not limited to market data, trading signals, price charts, educational articles, and analytics, is provided for informational and educational purposes only.

Nothing on this platform should be considered as:

Financial advice

Investment advice

Trading advice

Legal or tax advice

Users should consult qualified financial advisors or professionals before making any investment decisions.

Cryptocurrency Risk Warning

Cryptocurrencies and digital assets are highly volatile and speculative investments. Prices can fluctuate rapidly due to market demand, regulatory changes, technological developments, or other external factors.

Users acknowledge and accept the following risks:

High market volatility

Liquidity risks
Regulatory and legal uncertainty

Cybersecurity risks and hacking incidents

Technology risks including blockchain failures

Potential total loss of invested capital

You should only invest funds that you can afford to lose.

Trading Risk Disclosure

Trading cryptocurrencies involves significant risk and may not be suitable for all investors.

Key trading risks include:

Rapid price fluctuations

Slippage during market volatility

Liquidation risks in leveraged trading

System or network outages

Market manipulation or abnormal market conditions

Past performance of any cryptocurrency, trading strategy, or investment product does not guarantee future results.

Platform Availability

While IBullz Company strives to provide uninterrupted services, the platform does not guarantee that services will always be available without interruption.

The platform may experience downtime due to:

System maintenance

Network failures

Blockchain congestion

Security incidents

Technical issues

IBullz Company shall not be held liable for losses resulting from service interruptions.


              </p>
             <h5>Third-Party Services</h5>
              <p>
                The platform may include links or integrations with third-party services, wallets, payment gateways, or blockchain networks.
                IBullz Company does not control and is not responsible for the performance, security, or reliability of third-party services.
                Users interact with third-party services at their own risk.

              </p>

               <h5>Regulatory Compliance</h5>
              <p>
                Cryptocurrency regulations vary by jurisdiction. It is the user's responsibility to ensure compliance with the laws and regulations applicable in their country or region before using the platform.

Certain services may not be available in restricted jurisdictions.
              </p>

               <h5>Security Responsibility</h5>
              <p>
                Users are responsible for maintaining the security of their accounts, including:

Safeguarding passwords

Enabling two-factor authentication (2FA)

Protecting private keys or wallet credentials

IBullz Company will never request your password or private keys.

Losses caused by compromised accounts due to user negligence may not be recoverable.

Limitation of Liability

IBullz Company shall not be liable for any direct, indirect, incidental, consequential, or special damages arising from:

Cryptocurrency trading losses

Market volatility

Platform usage

Third-party service failures

Unauthorized account access

Users acknowledge that all trading and investment activities are undertaken at their own risk.


              </p>

              <h5>Acceptance of Terms</h5>

              <p>
               By using this platform, users confirm that they have read, understood, and agreed to this disclaimer and risk disclosure.
              </p>

              <p style={{ marginTop: "40px" }}>
              </p>

            </div>
          </div>
        </div>

        <div style={{ padding: "15px", textAlign: "center" }}>
          <button
            disabled={!canAccept}
            style={{
              padding: "10px 20px",
              background: canAccept ? "#00d1b2" : "#555",
              border: "none",
              color: "#000",
              cursor: canAccept ? "pointer" : "not-allowed"
            }}
            onClick={onAccept}  // 👈 only Accept closes modal
          >
            Accept & Continue
          </button>
        </div>

      </div>
    </div>
  );
}